module.exports = {
      id: "shortform-usage",
      viewBox: "0 0 13.07 13.758",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#shortform",
      toString: function () {
        return this.url;
      }
    }